import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=logged in

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("auth-logout", onLogout);
    return () => window.removeEventListener("auth-logout", onLogout);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  }, []);

  const impersonate = useCallback(async (userId) => {
    const { data } = await api.post("/auth/impersonate", { user_id: userId });
    setUser(data);
    return data;
  }, []);

  const stopImpersonation = useCallback(async () => {
    const { data } = await api.post("/auth/stop-impersonation");
    setUser(data);
    return data;
  }, []);

  return <AuthContext.Provider value={{ user, login, logout, impersonate, stopImpersonation }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
